// Format an ISO timestamp as MM/DD/YY HH:MM (UTC) for admin tables
export const formatAdminDate = (isoDateString: string): string => {
  const date = new Date(isoDateString);

  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const year = String(date.getUTCFullYear()).slice(-2);
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');

  return `${month}/${day}/${year} ${hours}:${minutes}`;
};
